import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  Col,
  Container,
  Input,
  InputGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import toast from "react-hot-toast";
import { Triangle } from "react-loader-spinner";
import blog from "../../assets/images/file.png";
import NewsService from "../../services/KangarooServices/NewsService.js";
import BreadCrumb from "../../Components/Common/BreadCrumb.js";
import DeleteModal from "../../Components/Common/DeleteModal.js";
import { imageBaseApi } from "../../utilis/imageHelper.js";

const NewsList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({ search: "", status: "" });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleFilterChange = (e) => {
    setFilters((prev) => ({ ...prev, search: e.target.value }));
  };
  const fetchPage = async () => {
    setIsLoading(true);
    try {
      const response = await NewsService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     setDebouncedFilters(filters);
  //     setCurrentPage(1);
  //   }, 500);
  //   return () => clearTimeout(timeoutId);
  // }, [filters]);

  useEffect(() => {
    fetchPage();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await NewsService.delete(selectedDeleteItem.id);
        fetchPage(currentPage, pageSize);
        toast.success("New deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  // Pagination controls
  const totalPages = Math.ceil(totalRows / pageSize);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="News" pageTitle="Content Management" />
        <Row className="mb-3">
          {/* <Col>
            <InputGroup>
              <Input
                placeholder="Search..."
                value={filters.search}
                onChange={handleFilterChange}
              />
            </InputGroup>
          </Col> */}
          <Col
            md={4}
            xs={12}
            className="d-flex justify-content-start align-items-end "
          >
            <Button
              className="btn btn-success"
              onClick={() => navigate("/news/create")}
            >
              + Create News
            </Button>
          </Col>
        </Row>
        {isLoading ? (
          <div className="my-3 d-flex justify-content-center align-content-center align-items-center">
            <Triangle visible height="80" width="80" />
          </div>
        ) : (
          <>
            <Row className="">
              {data?.map((item) => (
                <Col md={12} key={item.id}>
                  <Card className="shadow-sm border-0 rounded-3 page-card">
                    <Row className="g-0">
                      {/* Image Section */}

                      <Col lg={4}>
                        <div className="h-100 d-flex align-items-center align-content-center justify-content-center p-2 bg-light rounded-start">
                          <img
                            src={`${imageBaseApi}${item?.featuredMedia?.url}`}
                            alt="thumb"
                            className="img-fluid rounded-3 card-thumb"
                            style={{
                              height: "40vh",
                              objectFit: "contain",
                              width: "100%",
                            }}
                          />
                        </div>
                      </Col>
                      {/* Content Section */}
                      <Col lg={8}>
                        <CardBody className="d-flex flex-column p-3">
                          {item?.slug && (
                            <small className="text-uppercase text-muted fw-semibold mb-1">
                              {item.slug}
                            </small>
                          )}

                          <h5 className="fw-bold text-dark mb-1 news-title">
                            {item.title}
                          </h5>

                          {item?.subtitle && (
                            <p className="text-muted small mb-2 fst-italic">
                              {item.subtitle}
                            </p>
                          )}

                          <div className="d-flex align-items-center text-muted small mb-3">
                            <i className="ri-calendar-line me-1"></i>
                            {moment(item.createdAt).format(
                              "YYYY-MM-DD hh:mm A"
                            )}
                          </div>

                          <div
                            className="text-muted content-preview small"
                            dangerouslySetInnerHTML={{
                              __html:
                                item.shortDescription?.length > 10
                                  ? item.shortDescription.slice(0, 300) + "..."
                                  : item.content,
                            }}
                          />

                          <span
                            className="text-primary fw-semibold small mt-2 cursor-pointer"
                            onClick={() => navigate(`/news/${item.id}`)}
                          >
                            Read More →
                          </span>

                          {/* Bottom Actions */}
                          <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                            <Badge
                              pill
                              color={
                                item.status === "Draft" ? "warning" : "success"
                              }
                            >
                              {item.status}
                            </Badge>

                            <div className="d-flex gap-2">
                              <Button
                                color="btn btn-soft-warning"
                                size="sm"
                                onClick={() =>
                                  navigate(`/news/update/${item.id}`)
                                }
                              >
                                <i className="ri-edit-line" />
                              </Button>

                              <Button
                                color="btn btn-soft-danger"
                                size="sm"
                                onClick={() => handleDeleteClick(item)}
                              >
                                <i className="ri-delete-bin-5-line" />
                              </Button>
                            </div>
                          </div>
                        </CardBody>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Pagination */}
            <div className="d-flex justify-content-center align-content-center align-items-center">
              {totalPages > 1 && (
                <Pagination className="justify-content-center mt-4">
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                      previous
                      onClick={() => handlePageChange(currentPage - 1)}
                    />
                  </PaginationItem>

                  {[...Array(totalPages)].map((_, index) => (
                    <PaginationItem
                      key={index}
                      active={currentPage === index + 1}
                    >
                      <PaginationLink
                        onClick={() => handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </PaginationLink>
                    </PaginationItem>
                  ))}

                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      next
                      onClick={() => handlePageChange(currentPage + 1)}
                    />
                  </PaginationItem>
                </Pagination>
              )}
            </div>
          </>
        )}
      </div>

      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </Container>
  );
};

export default NewsList;
